import { GlobalErrorHandler } from '@core/global-error-handler';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  FeatureToggleModule,
  SecurityModule,
  UtcToLocalPipe,
  LibComponentsModule
} from '@mynexus/mynexus-ui-lib';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { API_PLATFORM_URL, API_URL } from '@core/config/api-base-url';
import { ConfirmationService } from 'primeng/api';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Carelon } from '@mynexus/theme';
import { providePrimeNG } from 'primeng/config';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    LibComponentsModule,
    FeatureToggleModule.forRoot(API_URL),
    SecurityModule.forRoot([{ url: API_PLATFORM_URL }], 'access-denied', 'codeManagement')
  ],
  providers: [
    UtcToLocalPipe,
    ConfirmationService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    providePrimeNG({
      ripple: false,
      theme: {
        preset: Carelon,
        options: {
          darkModeSelector: false
        }
      }
    })
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}